export const firebaseConfig = {
  apiKey: "AIzaSyBot0dE5HKpW_T9QZnPXriTqqmVd6jdNKc",
  authDomain: "chefswipe-f8d17.firebaseapp.com",
  projectId: "chefswipe-f8d17",
  storageBucket: "chefswipe-f8d17.appspot.com",
  messagingSenderId: "122005569813",
  appId: "1:122005569813:web:3b3e2a475bd1337c4de91c",
  measurementId: "G-M7GRTKNFF2",
};
